import { QRCode } from "react-qrcode-logo"
import ShareBar from "./ShareBar"
import { buildShareUrl, shareTitle } from "../utilities/share"

// QR code and share buttons for a place. Everything points at the place's
// chaperon.app link, which unfurls with its safety-level card.
export default function ShareSection({ place }) {
    const url = buildShareUrl(place?.slug)
    const title = shareTitle(place)

    return (
        <>
            <h6 className="text-center mb-3">Let others know...</h6>
            <details>
                <summary>
                    <kbd>
                        <i className="bi bi-qr-code"></i> QR Code
                    </kbd>
                </summary>
                <QRCode
                    size="300"
                    logoImage="/logo512.png"
                    logoWidth="300"
                    logoOpacity="0.2"
                    value={url}
                />
            </details>

            <ShareBar title={title} url={url} summary={title} />
        </>
    )
}
